/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BooleanInt32NullableKeyValuePair
 */
export interface BooleanInt32NullableKeyValuePair {
    /**
     * 
     * @type {boolean}
     * @memberof BooleanInt32NullableKeyValuePair
     */
    key?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BooleanInt32NullableKeyValuePair
     */
    value?: number | null;
}

export function BooleanInt32NullableKeyValuePairFromJSON(json: any): BooleanInt32NullableKeyValuePair {
    return BooleanInt32NullableKeyValuePairFromJSONTyped(json, false);
}

export function BooleanInt32NullableKeyValuePairFromJSONTyped(json: any, ignoreDiscriminator: boolean): BooleanInt32NullableKeyValuePair {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function BooleanInt32NullableKeyValuePairToJSON(value?: BooleanInt32NullableKeyValuePair | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value,
    };
}


